import React, { RefObject,useEffect } from 'react';

export const useRightPosition = (
  ref: RefObject<HTMLElement>,
  cssVarName: string,
): void => {
  const updatePosition = () => {
    if (ref.current) {
      const rect = ref.current.getBoundingClientRect();
      const padding = window.getComputedStyle(ref.current).paddingRight;
      const paddingRight = padding ? parseInt(padding, 10) : 0;
      const rightPosition = window.innerWidth - rect.right + paddingRight;
      document.documentElement.style.setProperty(`--${cssVarName}`, `${rightPosition}px`);
    }
  };

  useEffect(() => {
    updatePosition();
    window.addEventListener('resize', updatePosition);
    window.addEventListener('scroll', updatePosition);

    return () => {
      window.removeEventListener('resize', updatePosition);
      window.removeEventListener('scroll', updatePosition);
    };
  }, [ref, cssVarName]);
};
